var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("创建新次序")]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)]), _c('div', {
    staticClass: "task-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s draw"
    }, [_vm._v(" " + _vm._s(item.draw_index) + " ")]), _c('div', {
      staticClass: "s options"
    }, _vm._l(item.items, function (it) {
      return _c('div', {
        staticClass: "optionItem"
      }, [it && it.icon ? _c('img', {
        attrs: {
          "src": it.icon
        }
      }) : _vm._e(), _c('div', [_vm._v(" " + _vm._s(it.title) + "," + _vm._s(it.gift_extra?.gift_stars) + ", " + _vm._s(it.gift_extra.gift_type == 0 ? '电报原生' : "" + it.gift_extra.gift_type == 1 ? '电报NFT' : '其他') + " "), it.onlyShow ? _c('span', [_vm._v(" 【仅展示】 ")]) : _vm._e()])]);
    }), 0), _c('div', {
      staticClass: "s space"
    }), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.created_at)) + " ")]), _c('div', {
      staticClass: "s opt"
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onModify(item);
        }
      }
    }, [_vm._v("编辑")])])]);
  })], 2), _c('pop-luckylottery-logic', {
    attrs: {
      "show": _vm.popTaskShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popTaskShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s draw"
  }, [_vm._v(" 抽奖次序 ")]), _c('div', {
    staticClass: "s options"
  }, [_vm._v(" 奖项 ")]), _c('div', {
    staticClass: "s space"
  }), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 创建时间 ")]), _c('div', {
    staticClass: "s opt"
  })]);
}];
export { render, staticRenderFns };